import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 29.1vw;
  height: 52.591em;
  font-size: 12px;
  background: #6089BB;
  position: relative;

  .hide {
    display: none;
  }
  
  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .logo-rodape {
    width: 10em;
    position: absolute;
    top: 49.3em;
    left: 1.5em;
  }

  .barra-sup {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
  }

  .barra-sup3 {
    background: #1E4778;
    width: 12em;
    height: 14px;
    content: "";
    position: absolute;
    top: 51.45em;
    left: 25.2em;
  }

  .barra-sup2 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    top: 0;
    left: 12em;
    position: absolute;
  }

  .barra-sup4 {
    background: #4D78AD;
    width: 9em;
    height: 9px;
    content: "";
    position: absolute;
    top: 51.85em;
    left: 16.19em;
  }

  .header {
    margin-top: -2em;
    padding: 1.6em;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      .titulo {
        font-size: 9px;
        color: #FFFFFF;
        font-weight: 600;
      }

      .titulo-data {
        font-size: 9px;
        color: #D0D0D0;
      }
    }
  }
  
  .body {
    padding: 0.5em 3em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 40em;

    .mid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      height: 35rem;

      .titulo-orcamento {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        margin-top: -1rem;
      }

      .text {
        margin-top: 1em;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 24vw;
        background: #1E4778;
        border-radius: 1rem;
        padding: 1rem 2rem 2rem 2rem;
        
        .titulo-list {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .list {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .prod {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            width: 9.5vw;
            margin-top: 0.3rem;

            .img-check {
              width: 0.5rem;
              margin-top: 0.1rem;
            }

            .img-checked {
              width: 0.55rem;
              margin-top: 0.1rem;
            }

            .titulo {
              color: #fff;
              font-size: 8px;
              line-height: 10px;
              font-weight: 600;
              margin-left: 0.6rem;
            }
          }
        }
      }
          
      .tabela {
        width: 100%;
        margin-top: 1.5rem;

        .titulo-list {
          color: #fff;
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 0.5rem;
          margin-left: 0.9rem;
        }

        .item-plist {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0.2rem 1rem 0.8rem 1rem;

          .titulo {
            color: #fff;
            font-size: 10px;
            line-height: 10px;
            font-weight: 600;
            margin-top: 0.5rem;
          }
  
          .valor {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 6rem;
          }
        }

        .list {
          border-bottom: 1px dashed #fff;
          border-top: 1px dashed #fff;
          width: 100%;
          padding: 0.2rem 1rem 0.8rem 1rem;

          .titulo-item {
            color: #fff;
            font-size: 9px;
            line-height: 10px;
            font-weight: 300;
            margin-top: 0.5rem;
            width: 15rem;
          }

          .titulo {
            color: #fff;
            font-size: 9px;
            line-height: 10px;
            font-weight: 300;
            margin-top: 0.5rem;
          }
  
          .item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .valor {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 6rem;
            }
          }
        }
      }

      .tit {
        color: #5B5A5A;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 1em;
      }

      .titulo {
        color: #5B5A5A;
        font-size: 13px;
        font-weight: 600;
      }
    }
    
    .bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 24vw;
      margin-top: 1rem;

      .logo {
        display: flex;
        flex-direction: column;
        
        .logo-roda {
          width: 10rem;
        }

        .text-roda pre {
          font-size: 7px;
          color: #fff;
          font-weight: 400;
          margin-top: 0.6rem;
        }
      }

      .preco {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 13vw;
        height: 5rem;
        background: #1E4778;
        border-radius: 0.8rem;
        padding: 1rem;
        margin-top: 0.8rem;
        margin-left: 1rem;

        .descount {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          padding: 0 0.2rem;

          .percent {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            background: #6796CF;
            padding: 0.1rem 0.35rem;
            border-radius: 0.5rem;
            
            p {
              font-size: 11.5px;
              color: #254D7D;
              font-weight: 800;
            }
          }
            
          .valor-descont {
            font-size: 11px;
            color: #fff;
            font-weight: 600;
            text-decoration-line: line-through;
          }
        }

        .final-valor {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 0.2rem;

          .valor-descont {
            font-size: 18px;
            color: #6796CF;
            font-weight: 800;
          }
        }
      }
    }
  }

`;


export const Complemento = styled.div`
  content: "";
  width: 100%;
  background: #FFFFFF;

  ${props => {
    return `height: ${props?.height}px;`;
  }}
`